
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 311.63 56.6"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"レイヤー_2","data-name":"レイヤー 2"}},[_c('g',{attrs:{"id":"レイヤー_1-2","data-name":"レイヤー 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M0 0h56.6v56.6H0z"}}),_c('path',{staticClass:"cls-2",attrs:{"transform":"rotate(45 28.297 28.301)","d":"M8.43 8.43h39.74v39.74H8.43z"}}),_c('path',{staticClass:"cls-3",attrs:{"transform":"rotate(45 28.297 28.301)","d":"M13.16 13.16h30.28v30.28H13.16z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M85 0h56.6v56.6H85z"}}),_c('path',{staticClass:"cls-2",attrs:{"transform":"rotate(45 113.306 28.303)","d":"M93.43 8.43h39.74v39.74H93.43z"}}),_c('path',{staticClass:"cls-3",attrs:{"transform":"rotate(45 113.306 28.303)","d":"M98.16 13.16h30.28v30.28H98.16z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M170 0h56.6v56.6H170z"}}),_c('path',{staticClass:"cls-2",attrs:{"transform":"rotate(45 198.299 28.298)","d":"M178.43 8.43h39.74v39.74h-39.74z"}}),_c('path',{staticClass:"cls-3",attrs:{"transform":"rotate(45 198.299 28.298)","d":"M183.16 13.16h30.28v30.28h-30.28z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M255.03 0h56.6v56.6h-56.6z"}}),_c('path',{staticClass:"cls-2",attrs:{"transform":"rotate(45 283.325 28.307)","d":"M263.46 8.43h39.74v39.74h-39.74z"}}),_c('path',{staticClass:"cls-3",attrs:{"transform":"rotate(45 283.325 28.307)","d":"M268.19 13.16h30.28v30.28h-30.28z"}})])])])
          )
        }
      }
    